/* eslint-disable no-undefined */
import { TableSearch } from "../../../components/Table/TableActions";
import NotFounditem from "../../error/NotFound";
import nosearch from "../../../assets/images/no-search.svg";
import { httprequest } from "../../../data/api";
import TabContext from "@mui/lab/TabContext";
import Table from "../../../components/Table/Table";
import { Icon } from "@iconify/react";
import Tab from "@mui/material/Tab";
import { useEffect, useState } from "react";
import Tabs from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import PageLoader from "../../../components/PageLoader";
import Modal from "../../../components/Modal";
import { toast } from "react-toastify";
import useStyles from "../styles";
import Button from "../../../components/Button";
import Layout from "../../../components/Layout";
import BreadCrumb from "../../../components/BreadCrumb";
import InputGroup from "../../../components/FormComponent/InputGroup";
import useValidator from "../../../hooks/useValidator";
import { useParams, useNavigate } from "react-router-dom";
import SelectGroup from "../../../components/FormComponent/SelectGroup";
import { Grid } from "@mui/material";
import ButtonCount from "../../../components/ButtonCount";
import useWindowSize from "../../../hooks/useWindow";
import BulkSingleSubjectResultEntry from "../../classes/admin/BulkSingleSubjectResult";

// const CLASSES_ENDPOINT = "/api/v1/class";
const CLASS_SUBJECT = "/api/v1/class-subject/";
const GET_SUBJECT_GRADES = "/api/v1/grade/";
const GET_SESSIONS = "/api/v1/school-plan/session";
const TERM_ENDPOINT = "/api/v1/school-plan/terms";

const SUBJECT_CLASSES = "/api/v1/subjects/";
const GRADING_SYSTEM = "/api/v1/grading-system";
const CLASS_TEST_RESULT = "/api/v1/ca-test/result/";
const CLASS_EXAM_RESULT = "/api/v1/school-exams/result/";
const OBTAINABLE_SCORE = "/api/v1/obtainable-score";

// --| Dummy Data
// import SubjectResult from "../../../dummy_data/SubjectResult.json";

const AllSubjectResultDetails = () => {
  const classes = useStyles();
  const { id } = useParams();
  const navigate = useNavigate();
  // const [classesData, setClassData] = useState([]);
  const [value, setValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  // const [currentRow, setCurrentRow] = useState({});
  const [isPageFetching, setIsPageFetching] = useState(false);
  // const [deleteModal, setDeleteModal] = useState(false);
  // const [subjectArr, setSubjectArr] = useState([""]);
  const [classDetail, setClassDetail] = useState([]);
  const [classTestResult, setClassTestResult] = useState([]);
  const [classExamResult, setClassExamResult] = useState([]);
  const [addsubjectModal, setSubjectModal] = useState(false);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [autoCA, setAutoCA] = useState(false);
  const [allGradingSystem, setAllGradingSystem] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [allClassSubject, setAllClassSubject] = useState([]);
  const [obtainablescore, setObtainableScore] = useState([]);
  const [resultCreating, setResultCreating] = useState(false);
  const [classGrades, setClassGrades] = useState([]);
  // const [selectedSession, setSelectedSession] = useState("");
  const [aselectedTerm, setASelectedTerm] = useState("");
  const [allSessions, setAllSessions] = useState([]);
  const [aSubjectDetail, setASubjectDetail] = useState([]);
  const [selectedSessionTerms, setSelectedSessionTerms] = useState([]);
  const [activeSession, setActiveSession] = useState([]);
  const [calculatedGrade, setCalculatedGrade] = useState(null);
  const [studentResultValidator, showStudentResultValidator] = useValidator();
  const [subjectForm, setSubjectForm] = useState({
    subject_id: id,
    class_id: "",
    student_id: "",
    CA_scores: { CA1: "" },
    term_id: "",
    grade: "",
    grading_system_id: "",
    total: "",
    // exam_score: 0,
    CA_total: "",
    grade_type: "manual"
  });

  const width = useWindowSize();
  const mobile = width < 600;

  // Derive students from subject results (unique by id)
  const subjectStudents = Array.from(
    new Map(
      (classGrades || [])
        .map((res) => {
          const s = res?.student || {};
          const id = s?.student_id || s?.id;
          const name = `${s?.last_name || ""} ${s?.first_name || ""}`.trim();

          return [
            id,
            {
              student_id: id,
              first_name: s?.first_name,
              last_name: s?.last_name,
              name
            }
          ];
        })
    ).values()
  );

  // Handle opening bulk result modal
  const handleOpenBulkResultModal = () => {
    if (!aselectedTerm) {
      toast.error("Please select a term first");

      return;
    }
    if (!subjectStudents || subjectStudents.length === 0) {
      toast.error("No students found in this class");

      return;
    }
    setBulkModalOpen(true);
  };

  const handleCloseAddResultModal = () => {
    setSubjectModal(!addsubjectModal);
    setAutoCA(false);

    const initialCA = (obtainablescore?.[0]?.ca || [])?.reduce((acc, item) => {
      acc[item?.ca_type] = 0;

      return acc;
    }, {});

    setSubjectForm((prev) => ({
      ...prev,
      CA_scores: initialCA,
      CA_total: "",
      grade: "",
      grading_system_id: "",
      total: "",
      // exam_score: 0,
      student_id: ""
    }));
  };
  // const handleSubjectChange = (e, index) => {
  //   const { value } = e.target;
  //   const allSubjects = [...subjectArr];
  //   allSubjects[index] = value;
  //   setSubjectArr(allSubjects);
  //   setSubjectForm({ ...subjectForm, name: allSubjects });
  // };

  // const AddAdditionalSubject = () => {
  //   const newSubject = "";
  //   setSubjectArr([...subjectArr, newSubject]);
  //   setSubjectForm({ ...subjectForm, name: [...subjectArr, newSubject] });
  // };

  // const handleDeleteSubjectItem = (index) => {
  //   const newSubject = subjectArr.filter((_item, ind) => ind !== index);
  //   setSubjectArr(newSubject);
  //   setSubjectForm({ ...subjectForm, name: newSubject });
  // };

  // const handleCloseDeleteModal = () => {
  //   setDeleteModal(false);
  // };

  // Handle Get all Grading System
  const handleGetAllGradingSystem = () => {
    httprequest.get(GRADING_SYSTEM).then((res) => {
      setAllGradingSystem(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  // CA SCores Input
  const handleTestScoreChange = (e, caType) => {
    const inputRaw = e.target.value;

    // Remove leading zeros: "010" -> "10"
    const inputValue = inputRaw.replace(/^0+(?=\d)/, "");

    // Get max obtainable for this caType
    const maxObtainable = obtainablescore?.[0]?.ca?.find((item) => item.ca_type === caType)?.score || 0;

    // Validation
    if (Number(inputValue) > maxObtainable) {
      toast.error(`${caType} cannot exceed ${maxObtainable}`);

      return;
    }

    // Update CA_scores
    const updatedCA = {
      ...subjectForm?.CA_scores,
      [caType]: inputValue
    };

    // Compute CA_total and total
    const CA_total = Object.values(updatedCA).reduce((sum, val) => sum + (Number(val) || 0), 0);
    const examScore = parseInt(subjectForm?.exam_score) || 0;
    const totalScore = CA_total + examScore;

    // Determine grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade.min && totalScore <= grade.max
      );
      grade = gradeDetails ? gradeDetails?.grade : "";
    }

    setSubjectForm({
      ...subjectForm,
      CA_scores: updatedCA,
      CA_total: String(CA_total),
      total: String(totalScore),
      grade
    });
  };

  // Handle Select Grade system
  const handleGradeChange = (e) => {
    const selectedId = e.target.value;
    const selectedGradingSystem = allGradingSystem.find(
      (gradeSystem) => gradeSystem?.id === selectedId
    );

    setSelectedGrade(selectedGradingSystem);

    if (selectedGradingSystem && subjectForm?.total !== null) {
      const gradeDetails = selectedGradingSystem?.grading?.find(
        (grade) => subjectForm?.total >= grade?.min && subjectForm?.total <= grade?.max
      );

      if (gradeDetails) {
        setCalculatedGrade(gradeDetails?.grade);
        // Update the grade in the subjectForm state
        setSubjectForm((prevForm) => ({
          ...prevForm,
          grade: gradeDetails?.grade,
          grading_system_id: selectedId
        }));
      } else {
        toast.error("Total does not fall within any grade range.");
        // Optionally clear the grade if no range matches
        setSubjectForm((prevForm) => ({
          ...prevForm,
          grade: "",
          grading_system_id: ""
        }));
      }
    }
  };

  // No separate students endpoint/broad-sheet; students derived from subject results

  const getAllSubjectForClass = async (class_value) => {
    try {
      const res = await httprequest.get(`${CLASS_SUBJECT}${class_value}`);
      setAllClassSubject(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const handleTextChange = (e) => {
    const { name, value } = e.target.value;
    setSubjectForm({ ...subjectForm, [name]: value });
  };

  // const handleStudentChnage = (e) => {
  //   const value = e.target.value;
  //   setSubjectForm({ ...subjectForm, student_id: value });
  // };

  const handleExamScoreChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || 0;

    // Copy form state
    const updatedForm = { ...subjectForm, [name]: value };

    // Check exam_score validity
    if (name === "exam_score") {
      const maxExam = obtainablescore?.[0]?.examination || 0;

      if (numericValue > maxExam) {
        toast.error(`Exam score cannot exceed ${maxExam}!`);

        // Reset to previous valid value
        updatedForm.exam_score = Number(subjectForm?.exam_score) || 0;
      }
    }

    // CA_total and exam_score to calculate the total score
    const caTotal = parseFloat(updatedForm.CA_total) || 0;
    const examScore = parseFloat(updatedForm.exam_score) || 0;

    // Add and check total
    const totalScore = caTotal + examScore;
    updatedForm.total = totalScore;

    if (totalScore > 100) {
      toast.error("Total score cannot exceed 100!");
    }

    // Calculate the grade
    let grade = "";
    if (selectedGrade?.grading) {
      const gradeDetails = selectedGrade.grading.find(
        (grade) => totalScore >= grade?.min && totalScore <= grade?.max
      );
      grade = gradeDetails ? gradeDetails?.grade : "";

      // Update displayed grade
      setCalculatedGrade(grade);
    }

    updatedForm.grade = grade;

    // Update state
    setSubjectForm(updatedForm);
  };

  // Get all unique CA types from data
  const uniqueCAKeys = Array.from(
    new Set(
      classGrades?.flatMap(item => Object.keys(item?.CA_scores || {}))
    )
  );

  const dynamicCAColumns = uniqueCAKeys?.map((key) => ({
    name: key,
    selector: (row) => (
      <>
        {mobile && <p className="mobile-styling">{key}</p>}
        {row?.CA_scores?.[key] !== undefined ? row?.CA_scores[key] : "--/--"}
      </>
    ),
    sortable: true
  }));

  const columns = [
    {
      name: "Student Names",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Student Names</p>}
          {`${row?.student?.first_name} ${row?.student?.last_name}` || "--/--"}
        </>
      )
    },
    ...dynamicCAColumns,
    {
      name: "CA Score",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">CA Score</p>}
          {parseInt(row?.CA_total) || "--/--"}
        </>
      )
    },
    {
      name: "Exam Score",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Exam Score</p>}
          {parseInt(row?.exam_score) || "--/--"}
        </>
      )
    },
    {
      name: "Total",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Total</p>}
          {parseInt(row?.total) || "--/--"}
        </>
      )
    },
    {
      name: "Grade",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Grade</p>}
          {row?.grade || "--/--"}
        </>
      )
    },
    {
      name: "Date",
      selector: row => (
        <>
          {mobile && <p className="mobile-styling">Date</p>}
          {row?.created_at.substring(0, 10) || "--/--"}
        </>
      )
    }
  ];

  const getAllTerms = (Session_ID) => {
    httprequest
      .get(TERM_ENDPOINT)
      .then((res) => {
        setSelectedSessionTerms(res?.data?.data.filter((selected_term) => selected_term?.session_id === Session_ID));
      });
    // .catch(() => {});
  };

  // Handle Get All Classes
  const getAllSessions = async () => {
    try {
      const res = await httprequest.get(GET_SESSIONS);
      setAllSessions(res?.data?.data);
      setActiveSession(res?.data?.data?.find((active_session) => active_session?.current_session === true));
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  // Get Subject result
  const handleGetSubjectResult = async (termId, class_value) => {
    setIsPageFetching(true);
    try {
      const res = await httprequest.get(`${GET_SUBJECT_GRADES}${id}/${class_value}?term_id=${termId}`);
      setIsPageFetching(false);
      setClassGrades(res?.data?.data);
      setSearchResult(res?.data?.data);
    } catch (err) {
      setIsPageFetching(false);
      toast.error(err?.response?.data?.message);
    }
  };

  // Get A Subject Detail
  const handleGetASubjectById = () => {
    httprequest.get(`${SUBJECT_CLASSES}${id}`).then((res) => {
      setASubjectDetail(res?.data?.data);
    }).catch((err) => {
      toast.error(err?.response?.data?.message);
    });
  };

  // Find Active Term in an Current Session
  const active_term_session = activeSession?.terms?.find((found_active_term) => found_active_term?.is_current === true);

  // Handles the change event when a new tab is selected
  const handleTermChange = (event) => {
    const selectedTermId = event.target.value;
    setASelectedTerm(selectedTermId);
    handleGetSubjectResult(selectedTermId, value);
  };

  /**
     * Fetches all obtainable scores from the API
     */
  const getAllObtainableScores = () => {
    // setIsLoading(true);
    httprequest
      .get(OBTAINABLE_SCORE)
      .then((res) => {
        setObtainableScore(res?.data?.data?.filter((scores) => scores?.session?.id === active_term_session?.session_id));
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  // Create Add Student Result
  const handlePostStudentResult = () => {
    if (studentResultValidator.allValid()) {
      setResultCreating(true);
      httprequest.post(GET_SUBJECT_GRADES, { ...subjectForm, term_id: aselectedTerm }).then((res) => {
        setResultCreating(false);
        toast.success(res?.data?.message);
        handleGetSubjectResult(aselectedTerm, value);
        handleCloseAddResultModal();
      }).catch((err) => {
        setResultCreating(false);
        toast.error(err?.response?.data?.message);
      });
    } else {
      showStudentResultValidator(true);
    }
  };

  const filteredResults = classTestResult?.filter(item => item?.student?.id === subjectForm?.student_id &&
    item?.subject?.id === subjectForm?.subject_id
  );

  const handleAutoCAChange = (e) => {
    const isChecked = e.target.checked;
    setAutoCA(isChecked);

    if (isChecked && filteredResults.length > 0) {
      const selectedResult = filteredResults[0];
      const updatedCAScores = { ...selectedResult.ca_scores };

      const totalCA = Object.values(updatedCAScores).reduce(
        (sum, score) => sum + (Number(score) || 0),
        0
      );

      setSubjectForm((prev) => ({
        ...prev,
        CA_scores: updatedCAScores,
        CA_total: String(totalCA),
        total: String(totalCA),
        grade_type: "auto"
      }));
    } else {
    // Reset on uncheck
      setSubjectForm((prev) => ({
        ...prev,
        CA_scores: {},
        CA_total: "",
        total: "",
        exam_score: "",
        grade_type: "manual"
      }));
    }
  };

  // Handle Session Change
  const handleSessionChange = (e) => {
    const Session_ID = e.target.value;
    // setASelectedSession(e.target.value);
    getAllTerms(Session_ID);
  };

  // --| Filter Student table using name, email and class
  const handleSearchInventory = (e) => {
    const { value } = e.target;

    const valArray = value.split(" ");
    // --| Filter data by partial match onchange in the search input box
    const result = classGrades?.filter((data) => valArray?.every(
      (word) => data?.name
        ?.toLowerCase()
        .includes(word.toLowerCase()) ||
                                    data?.description
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                    data?.category
                                      ?.toLowerCase()
                                      .includes(word.toLowerCase()) ||
                                      data?.status
                                        ?.toLowerCase()
                                        .includes(word.toLowerCase())
    )
    );
    setSearchResult(result);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSubjectForm({ ...subjectForm, class_id: newValue });
    getAllSubjectForClass(newValue);
    handleGetSubjectResult(aselectedTerm, newValue);
  };

  useEffect(() => {
    if (active_term_session?.id) {
      setASelectedTerm(active_term_session.id);
      getAllObtainableScores();
    }
  }, [active_term_session]);

  useEffect(() => {
    if (activeSession?.id) {
      // setSelectedSession(activeSession?.id);
      getAllTerms(activeSession?.id);
    }
  }, [activeSession]);

  useEffect(() => {
    getAllSessions();
    handleGetAllGradingSystem();
    handleGetASubjectById();
  }, []);

  useEffect(() => {
    if (obtainablescore?.[0]?.ca?.length > 0) {
      const initialCA = obtainablescore?.[0]?.ca.reduce((acc, item) => {
        acc[item?.ca_type] = 0;

        return acc;
      }, {});

      setSubjectForm((prev) => ({
        ...prev,
        CA_scores: initialCA
      }));
    }
  }, [obtainablescore]);

  const getClassTestResult = (aselectedTerm, class_value) => {
    // setGetIsLoading(true);
    httprequest
      .get(`${CLASS_TEST_RESULT}${class_value}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassTestResult(res?.data?.data);
        // setGetIsLoading(false);
      }).catch((err) => {
        // setGetIsLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const getClassExamResult = (aselectedTerm, class_value) => {
    httprequest
      .get(`${CLASS_EXAM_RESULT}${class_value}?term_id=${aselectedTerm}`)
      .then((res) => {
        setClassExamResult(res?.data?.data);
      }).catch(() => {
        // toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      if (!id || !active_term_session?.id) return;

      setIsFetching(true);

      try {
      // 1. Fetch class details
        const res = await httprequest.get(`${SUBJECT_CLASSES}${id}/classes`);
        const classData = res?.data?.data;
        setClassDetail(classData);

        // 2. If there's at least one class and no selected value
        if (classData?.length > 0 && !value) {
          const classValue = classData[0]?.id;
          setValue(classValue);

          setSubjectForm({ ...subjectForm, class_id: classValue, term_id: active_term_session.id });
          getAllSubjectForClass(classValue);
          handleGetSubjectResult(active_term_session.id, classValue);
          getClassTestResult(active_term_session.id, classValue);
          getClassExamResult(active_term_session.id, classValue);

          // Students will be derived from subject results; no extra fetch
        } else if (classData?.length > 0 && value) {
          // Students will be derived from subject results; no extra fetch
        }
      } catch (err) {
        toast.error(err?.response?.data?.message);
      } finally {
        setIsFetching(false);
      }
    };

    fetchInitialData();
  }, [id, active_term_session]);

  // Helper function to get current selected class details
  const getCurrentClassDetails = () => {
    if (!value || classDetail.length === 0) return null;

    return classDetail.find(cls => String(cls?.id) === String(value));
  };

  const currentClass = getCurrentClassDetails();

  return (
    <Layout children={
      <div>
        <div className="breadcrumb-container">
          <div>
            <BreadCrumb link_one="/class-activities/subjects" link_one_name="My Subjects" active={aSubjectDetail?.name} description="See academic result of each student taking a subject for each classes" />
          </div>
          <div className="flex gap-10">
            {/* <Button
              onClick={handleAddSubjectModal}
              variant="primaryoutline"
              buttonSize="fluid"
              color="btnfontprimary"
              buttonName="Add Student Result"
            /> */}
            <Button
              onClick={handleOpenBulkResultModal}
              variant="primary"
              buttonSize="fluid"
              color="btndefault"
              buttonName="Add Student Results"
            />
          </div>
        </div>
        <TabContext value={value}>
          <div className="tablist-container margin-bottom">
            {isFetching ? (
              <div className="container-left">
                <Icon icon="eos-icons:three-dots-loading" width="50" height="50" />
              </div>
            ) : classDetail.length > 0 ? (
              <Tabs
                className="overide-tablist"
                onChange={handleChange}
                aria-label=""
              >
                {classDetail.map((data, i) => (
                  <Tab key={i} value={data?.id} label={data?.class_name} />
                ))}
              </Tabs>
            ) : (
              <div className={classes.noclass}>
                <p>Sorry No Class has been assigned to this subject</p>
                <Icon icon="ep:warning" />
              </div>
            )}

          </div>
          <div className="page-content">
            <div className="action_div flex-wrap-items-600">
              <div className={`${classes.contentpadding} padding-left-16`}>
                <ButtonCount func={() => navigate("")} title="No of Results" count={classGrades?.length} />
              </div>
              <div className="flex gap-10 align-items-end margin-top-5 margin-bottom-14">
                <div className="margin-bottom-10">
                  {isPageFetching ? <Icon icon="svg-spinners:270-ring-with-bg" width="20" height="20" style={{ color: "#858585" }} />
                    : <Icon onClick={() => handleGetSubjectResult(active_term_session?.id, value)} icon="hugeicons:reload" width="20" height="20" style={{ color: "#858585" }} />}
                </div>
                <div>
                  {activeSession?.id && (
                    <SelectGroup
                      children={
                        <select
                          defaultValue={activeSession?.id}
                          onChange={handleSessionChange}
                          name="session"
                        >
                          <option value="">---Select---</option>
                          {allSessions?.map((sesh) => {
                            return (
                              <option key={sesh?.id} value={sesh?.id}>
                                {sesh?.session}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
                <div>
                  {active_term_session?.id && (
                    <SelectGroup
                      children={
                        <select onChange={handleTermChange} name="term" value={aselectedTerm}>
                          <option value="">---Select---</option>
                          {selectedSessionTerms?.map((data) => {
                            return (
                              <option key={data?.id} value={data?.id}>
                                {data?.term}
                              </option>
                            );
                          })}
                        </select>
                      }
                    />
                  )}
                </div>
              </div>
            </div>
            {classDetail?.map((data, i) => (
              <TabPanel className="tabpanel-overide" key={i} value={data?.id}>
                {isPageFetching ? (
                  <PageLoader />
                ) : searchResult.length > 0 ? (
                  <Table
                    data={searchResult}
                    columns={columns}
                    subHeader={true}
                    pagination
                    subHeaderComponent={
                      searchResult?.length > 0 && (
                        <TableSearch
                          placeholder="Search here..."
                          searchTableFunc={handleSearchInventory}
                        />
                      ) }
                  />
                ) : (
                  <div className={classes.notfound}>
                    <NotFounditem
                      img={nosearch}
                      title="No Result"
                      subtitle="No result has been added to the list."
                    />
                  </div>
                )}
              </TabPanel>
            ))}
          </div>
        </TabContext>

        {/* Add Results */}
        <Modal
          title="Add Result"
          subtitle={
            <div>
                Manually add your student's result.
              <div className={classes.noclass}>
                {classDetail?.length === 0 ? (
                  <p>Sorry No Class has been assigned to this subject hence, result can't be added.</p>
                ) : null}
              </div>
            </div>
          }
          modalContent={
            <>
              <Grid container spacing={2} className="input-padding">
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Class"
                    required
                    children={
                      <select disabled value={value} name="class_id">
                        <option value="">--- Select ---</option>
                        {classDetail?.map((class_id) => {
                          return (
                            <option key={class_id.id} value={class_id?.id}>
                              {class_id?.class_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Class", subjectForm?.class_id, "required")}
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <SelectGroup
                    label="Subject"
                    required
                    children={
                      <select disabled value={id} name="subject_id" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {allClassSubject?.map((subject) => {
                          return (
                            <option key={subject.subject_id} value={subject?.subject_id}>
                              {subject?.subject_name}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Subject", subjectForm?.subject_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  {/* <SelectGroup
                    label="Students"
                    required
                    children={
                      <select name="student_id" onChange={handleStudentChnage}>
                        <option value="">--- Select ---</option>
                        {allStudent?.map((student) => {
                          return (
                            <option key={student?.student?.student_id} value={student?.student?.student_id}>
                              {`${student?.student?.last_name} ${student?.student.first_name}`}
                            </option>
                          );
                        })}
                      </select>
                    }
                  /> */}
                  {studentResultValidator.message("Student", subjectForm?.student_id, "required")}
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <label>
                    <input
                      type="checkbox"
                      disabled={filteredResults.length === 0}
                      onChange={handleAutoCAChange}
                    />
                                        Add Score from CA Test
                  </label>
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    {autoCA ? (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => {
                          const existingValue = subjectForm?.CA_scores?.[item.ca_type];

                          return (
                            <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                              <InputGroup
                                label={item?.ca_type}
                                margin="normal"
                                required
                                placeHolder="Enter score"
                                inputType="number"
                                value={existingValue ?? 0}
                                onChange={(e) => handleTestScoreChange(e, item.ca_type)}
                              />
                              {/* {
                                studentResultValidator.message(
                                  item?.ca_type,
                                  subjectForm?.CA_scores?.[item?.ca_type],
                                  "required"
                                )} */}
                            </Grid>
                          );
                        })}
                      </>
                    ) : (
                      <>
                        {obtainablescore?.[0]?.ca?.map((item, index) => (
                          <Grid key={index} item lg={6} md={6} sm={12} xs={12}>
                            <InputGroup
                              label={item?.ca_type}
                              margin="normal"
                              required
                              placeHolder="Enter score"
                              inputType="number"
                              onChange={(e) => handleTestScoreChange(e, item?.ca_type)}
                              value={subjectForm?.CA_scores?.[item?.ca_type] ?? 0}
                            />
                            {/* {studentResultValidator.message(
                              item?.ca_type,
                              subjectForm?.CA_scores?.[item?.ca_type],
                              "required"
                            )} */}
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Total CA Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="CA_total"
                    value={subjectForm?.CA_total}
                    disabled
                  />
                  {studentResultValidator.message("CA Total", subjectForm?.CA_total, "required")}
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <InputGroup
                    label="Exam Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="exam_score"
                    onChange={handleExamScoreChange}
                  />
                  {/* {studentResultValidator.message("Exam Score", subjectForm?.exam_score, "required")} */}
                </Grid>
                <Grid item lg={4} md={12} sm={12} xs={12}>
                  <InputGroup
                    label="Total Score"
                    margin="normal"
                    inputType="number"
                    required
                    inputName="total"
                    value={subjectForm?.total || 0}
                    disabled
                  />
                  {studentResultValidator.message("Total Score", subjectForm?.total, "required")}
                </Grid>
                <Grid item lg={9} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade System"
                    required
                    children={
                      <select name="grading_system_id" onChange={handleGradeChange}>
                        <option value="">--- Select ---</option>
                        {allGradingSystem?.map((grade_system) => {
                          return (
                            <option key={grade_system?.id} value={grade_system?.id}>
                              {grade_system?.title}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                </Grid>
                <Grid item lg={3} md={12} sm={12} xs={12}>
                  <SelectGroup
                    label="Grade"
                    required
                    children={
                      <select disabled value={calculatedGrade || ""} name="grade" onChange={handleTextChange}>
                        <option value="">--- Select ---</option>
                        {selectedGrade?.grading?.map((grade_type) => {
                          return (
                            <option key={grade_type?.grade} value={grade_type?.grade}>
                              {grade_type?.grade}
                            </option>
                          );
                        })}
                      </select>
                    }
                  />
                  {studentResultValidator.message("Grade", subjectForm?.grade, "required")}
                </Grid>
              </Grid>
            </>
          }
          modalFooter={
            <>
              <div className={classes.modalFooterBtn}>
                <Button
                  variant="primary"
                  buttonSize="full"
                  color="btndefault"
                  buttonName="Add Result"
                  disabled={classDetail.length === 0}
                  onClick={handlePostStudentResult}
                  isLoading={resultCreating}
                />
              </div>
            </>
          }
          isopen={addsubjectModal}
          closeModal={handleCloseAddResultModal}
        />

        {/* Bulk Single Subject Result Entry Modal */}
        <BulkSingleSubjectResultEntry
          open={bulkModalOpen}
          onClose={() => setBulkModalOpen(false)}
          classId={value}
          className={currentClass?.class_name}
          subject={aSubjectDetail}
          termId={aselectedTerm}
          termName={selectedSessionTerms?.find(term => term.id === aselectedTerm)?.term}
          session={activeSession?.session}
          students={subjectStudents}
          obtainableScores={obtainablescore}
          gradingSystems={allGradingSystem}
          existingResults={classGrades}
          classTestResults={classTestResult}
          classExamResults={classExamResult}
          onSave={async (data) => {
            try {
              setBulkLoading(true);
              const res = await httprequest.post(GET_SUBJECT_GRADES, data);
              toast.success(res?.data?.message);
              handleGetSubjectResult(aselectedTerm, value);
              setBulkModalOpen(false);
            } catch (err) {
              toast.error(err?.response?.data?.message);
            } finally {
              setBulkLoading(false);
            }
          }}
          isLoading={bulkLoading}
        />
      </div>
    }
    />
  );
};

export default AllSubjectResultDetails;
